module.exports = __webpack_public_path__ + "img/MTABAPPPWV.758ed2db.svg";